import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { queryClient } from "@/api";
import { getAdminPermissions } from "@/api/methods";
import { Button } from "atoms/Button";
import { ReactComponent as FrownIcon } from "atoms/icons/frown.svg";

export type AuthorizationErrorViewProps = {
  "className"?: string;
  "data-testid"?: string;
};

export const AuthorizationErrorView = ({
  className = "flex min-h-screen w-full items-center justify-center bg-background",
  "data-testid": dataTestId,
}: AuthorizationErrorViewProps) => {
  const navigate = useNavigate();

  /**
   * There's a chance that user's permissions changed right while
   * the user was navigating the app.
   * Invalidate `/auth/permissions` endpoint so that we refetch
   * them.
   */
  useEffect(() => {
    queryClient.invalidateQueries(getAdminPermissions.keyed());
    queryClient.invalidateQueries({ queryKey: ["platformPermissions"] });
  }, []);

  return (
    <div className={className}>
      <div
        className="flex flex-col items-center justify-center px-2 text-center"
        data-testid={dataTestId}
      >
        <FrownIcon title="Sad face" />
        <p className="mt-4 text-bold1">
          Looks like you don&apos;t have permission to view this page.
        </p>
        <p className="mt-4 text-bold1">
          If you need access, please contact your platform&apos;s administrator.
        </p>
        <div className="mt-8 flex gap-7">
          <Button
            style="outline"
            /**
             * This intentionally leads to platform-overview
             * because (unlike `/` or `/admin/platforms/`) it correctly
             * handles multi-platform user case.
             */
            onClick={() => navigate("/admin/platform-overview/")}
          >
            Return to your Home page
          </Button>
        </div>
      </div>
    </div>
  );
};
